
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _404Xy9amFcS2qsPtYWK_45cTrhVGnV6bZOC_45_45loDT3jPAVz4Meta } from "/home/mycarrental/mcr-nuxt/pages/404.vue?macro=true";
import { default as payMpCgMeGzSTk9uOrSKbXY4GRxHBFgLx77G0Y5etT0jrcMeta } from "/home/mycarrental/mcr-nuxt/pages/pay.vue?macro=true";
import { default as _slugvee1D1_nQPw1r6AbNEvgtIymkqLlfeN9L6I67YpJdQUMeta } from "/home/mycarrental/mcr-nuxt/pages/_slug.vue?macro=true";
import { default as indexlws7E_45irQnw9sabMvRJ1a5Eh6NPFafjjfuZsMfOhojcMeta } from "/home/mycarrental/mcr-nuxt/pages/index.vue?macro=true";
import { default as termsNwcnoh2oYaRZLV8rAtPvDAxVXJDgCtFzze624eCBX6sMeta } from "/home/mycarrental/mcr-nuxt/pages/terms.vue?macro=true";
import { default as Bookingm4pbVLucrhvn_JfPm6qvUYc8oN2mZqjAbKwClkkWu24Meta } from "/home/mycarrental/mcr-nuxt/pages/Booking.vue?macro=true";
import { default as about_45usp3axuhCKJ7VtI8FdVknChHMhzkD6OozzeHVSepDZnlEMeta } from "/home/mycarrental/mcr-nuxt/pages/about-us.vue?macro=true";
import { default as contactspmN3LXOmijBs5t_45aJuZe30KD92HiFH7cqDvjJ8TZZ74Meta } from "/home/mycarrental/mcr-nuxt/pages/contacts.vue?macro=true";
import { default as _91id_93b_E3oKw5D349zlGNuWJeLxSuiLwfZO0uKKvo9gKS7hYMeta } from "/home/mycarrental/mcr-nuxt/pages/blog/[id].vue?macro=true";
import { default as corporate2AENyD9i8PrOPU_Ekf9DY8hv4q4tqQJDPtXSChc0CEYMeta } from "/home/mycarrental/mcr-nuxt/pages/corporate.vue?macro=true";
import { default as franchise1tBTOhDa_45BaUUuN8mF_45CZsqnsMyjHUtU6qpb5AZUp30Meta } from "/home/mycarrental/mcr-nuxt/pages/franchise.vue?macro=true";
import { default as partnerkafn3hd_452tUuVy0wWEH5OwWlG988sMNd9LbN_45fEHsuAtAMeta } from "/home/mycarrental/mcr-nuxt/pages/partnerka.vue?macro=true";
import { default as indexV0HsXzaCz8TeeAOdugrHQEemcHSbqMKZl2Z1TIzgZAEMeta } from "/home/mycarrental/mcr-nuxt/pages/blog/index.vue?macro=true";
import { default as user_45agreement4xXC_Zq2UEY_xCmm_45gDXHlfi7BILiBxpqLuZHM_45_dIoMeta } from "/home/mycarrental/mcr-nuxt/pages/user-agreement.vue?macro=true";
import { default as _91id_93ro9cS2QfyiWN_xmc6VmKLBhQ9QpO8AHLIp30gdDF3rsMeta } from "/home/mycarrental/mcr-nuxt/pages/reservation/[id].vue?macro=true";
import { default as payment_45completedmEF72a86JeygBGXdR_mOT_kqG6agC8NDPWUosKZ_c_458Meta } from "/home/mycarrental/mcr-nuxt/pages/payment-completed.vue?macro=true";
import { default as _slugg3_458UuztuQA_r5TjjlsXS_45HcPsqbAk9s9KZD1QwteNUMeta } from "~/pages/_slug.vue?macro=true";
import { default as about_45us7WVzbODNRweZg6ueroBaIn7b8x3NFPGPh1ImuWObPXsMeta } from "~/pages/about-us.vue?macro=true";
import { default as _91id_93hI1_KOu_45kWiqJ_45OzDqUfkekULR_45MffZaYP_45KzwD6f2sMeta } from "~/pages/blog/[id].vue?macro=true";
import { default as termsz0m31nlE_45IB9JYtqePioEiqjnuKJMWK_45oeL30QF2R40Meta } from "~/pages/terms.vue?macro=true";
import { default as user_45agreement2oWmSu75Zk48rBF0LjvguFi2zOQE_45Okh7sl1tNoQO_0Meta } from "~/pages/user-agreement.vue?macro=true";
import { default as payBcElyt1mxkRrUFuKVudx9onN28XgCen_ziiJk0IbfwAMeta } from "~/pages/pay.vue?macro=true";
import { default as payment_45completedJ7v4TglkYFA_5coskXmTujsdaNG_45mtmUaH5UdTu39IcMeta } from "~/pages/payment-completed.vue?macro=true";
import { default as index8kcUChGNqgEGryxfywu4kvnNqvKM9YmS96G5nR0juasMeta } from "~/pages/index.vue?macro=true";
import { default as _404sN0yY11_45ylE83Gd8Wq9fxtkpdDFaU_fJ8wDZpai6_450oMeta } from "~/pages/404.vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    meta: _404Xy9amFcS2qsPtYWK_45cTrhVGnV6bZOC_45_45loDT3jPAVz4Meta || {},
    component: () => import("/home/mycarrental/mcr-nuxt/pages/404.vue")
  },
  {
    name: "pay",
    path: "/pay",
    component: () => import("/home/mycarrental/mcr-nuxt/pages/pay.vue")
  },
  {
    name: "_slug",
    path: "/_slug",
    component: () => import("/home/mycarrental/mcr-nuxt/pages/_slug.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/mycarrental/mcr-nuxt/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/home/mycarrental/mcr-nuxt/pages/terms.vue")
  },
  {
    name: "Booking",
    path: "/Booking",
    component: () => import("/home/mycarrental/mcr-nuxt/pages/Booking.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/home/mycarrental/mcr-nuxt/pages/about-us.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    component: () => import("/home/mycarrental/mcr-nuxt/pages/contacts.vue")
  },
  {
    name: "blog-id",
    path: "/blog/:id()",
    component: () => import("/home/mycarrental/mcr-nuxt/pages/blog/[id].vue")
  },
  {
    name: "corporate",
    path: "/corporate",
    component: () => import("/home/mycarrental/mcr-nuxt/pages/corporate.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/home/mycarrental/mcr-nuxt/pages/franchise.vue")
  },
  {
    name: "partnerka",
    path: "/partnerka",
    component: () => import("/home/mycarrental/mcr-nuxt/pages/partnerka.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/home/mycarrental/mcr-nuxt/pages/blog/index.vue")
  },
  {
    name: "user-agreement",
    path: "/user-agreement",
    component: () => import("/home/mycarrental/mcr-nuxt/pages/user-agreement.vue")
  },
  {
    name: "reservation-id",
    path: "/reservation/:id()",
    component: () => import("/home/mycarrental/mcr-nuxt/pages/reservation/[id].vue")
  },
  {
    name: "payment-completed",
    path: "/payment-completed",
    component: () => import("/home/mycarrental/mcr-nuxt/pages/payment-completed.vue")
  },
  {
    name: "city",
    path: "/:slug",
    component: () => import("~/pages/_slug.vue")
  },
  {
    name: "region",
    path: "/regions/:slug",
    component: () => import("~/pages/_slug.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("~/pages/about-us.vue")
  },
  {
    name: "news_page",
    path: "/regions/:city/:slug",
    component: () => import("~/pages/blog/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("~/pages/terms.vue")
  },
  {
    name: "user-agreement",
    path: "/user-agreement",
    component: () => import("~/pages/user-agreement.vue")
  },
  {
    name: "pay",
    path: "/pay",
    component: () => import("~/pages/pay.vue")
  },
  {
    name: "payment-completed",
    path: "/payment-completed/:payment_id",
    component: () => import("~/pages/payment-completed.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("~/pages/index.vue")
  },
  {
    name: "404",
    path: "/404",
    meta: _404sN0yY11_45ylE83Gd8Wq9fxtkpdDFaU_fJ8wDZpai6_450oMeta || {},
    component: () => import("~/pages/404.vue")
  }
]